import React, { useEffect, useState } from 'react';
import Textfield from '@atlaskit/textfield';
import Select, { AsyncSelect, components } from '@atlaskit/select';
import {
  faAngleDown,
  faSearch,
  faMapLocationDot,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons';
import { Container, Card, Title, Row, RowSearch, SelectCustom } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { optionsRegime, optionsModel } from './options';
import { apiCityState } from '../../services/api';

function Search({
  searchState,
  optionsDepartments,
  departmentSelectedState,
  locationSelectedState,
  regimeSelectedState,
  modelSelectedState,
}) {
  const [search, setSearch] = searchState;
  const [departmentSelected, setDepartmentSelected] = departmentSelectedState;
  const [locationSelected, setLocationSelected] = locationSelectedState;
  const [regimeSelected, setRegimeSelected] = regimeSelectedState;
  const [modelSelected, setModelSelected] = modelSelectedState;
  const [noShowFilter, setNoShowFilter] = useState(true);

  const loadLocationOptions = async (inputValue) => {
    if (inputValue.length < 3) {
      return [];
    }
    
    try {
      const response = await apiCityState.get(`/search/locations?q=${inputValue}`);
      return response.data.items.map(item => ({
        label: `${item.city} - ${item.code}`,
        value: `${item.city} - ${item.code}`,
      }));
    } catch (error) {
      console.error('Location search failed:', error);
      return [
        {
          label: 'Error loading locations. Please try again.',
          value: null,
          isDisabled: true,
        },
      ];
    }
  };

  const CustomOption = props => {
    const { data, children, ...rest } = props;
    return (
      <components.Option {...rest}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FontAwesomeIcon
            icon={faLocationDot}
            style={{
              fontSize: 18,
              marginLeft: '8px',
              color: '#7A869A',
              fontWeight: 'normal',
            }}
          />
          {children}
        </span>
      </components.Option>
    );
  };

  const CustomDropdownIndicator = () => null;

  const CustomPlaceholder = props => {
    return (
      <components.Placeholder {...props}>
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: '#888',
          }}
        >
          <FontAwesomeIcon
            icon={faMapLocationDot}
            style={{
              fontSize: 18,
              marginLeft: '8px',
              color: '#7A869A',
              fontWeight: 'normal',
            }}
          />
          {props.children}
        </span>
      </components.Placeholder>
    );
  };

  useEffect(() => {
    const queryParams = new URLSearchParams();
    if (search) queryParams.set('search', search);
    if (departmentSelected && departmentSelected.value)
      queryParams.set('department', departmentSelected.value);
    if (locationSelected) queryParams.set('location', locationSelected.value);
    if (regimeSelected) queryParams.set('regime', regimeSelected.value);
    if (modelSelected) queryParams.set('model', modelSelected.value);
    const newUrl = `${window.location.pathname}${
      queryParams.toString() ? '?' + queryParams.toString() : ''
    }`;
    window.history.pushState({}, '', newUrl);
  }, [
    search,
    departmentSelected,
    locationSelected,
    regimeSelected,
    modelSelected,
  ]);

  return (
    <Container>
      <Card showFilter={noShowFilter}>
        <Title className="title-desktop">
          Encontre as vagas que combinam com você
        </Title>
        <Title className="title-mobile" showFilter={noShowFilter}>
          Mostrar Filtros
          <FontAwesomeIcon
            icon={faAngleDown}
            style={{ width: '16px' }}
            onClick={() => setNoShowFilter(old => !old)}
          />
        </Title>
        <RowSearch>
          <div className="field" style={{ minWidth: '200px' }}>
            <Textfield
              id="searchfield"
              placeholder={'Busque por cargo ou palavra-chave'}
              value={search}
              onChange={e => setSearch(e.target.value)}
              elemBeforeInput={
                <FontAwesomeIcon
                  icon={faSearch}
                  style={{
                    fontSize: 18,
                    marginLeft: '8px',
                    color: '#7A869A',
                    fontWeight: 'normal',
                  }}
                />
              }
            />
          </div>
          <div className="field" style={{ minWidth: '200px' }}>
            <SelectCustom>
              <AsyncSelect
                instanceId="location-select"
                placeholder="Cidade e/ou estado"
                loadOptions={loadLocationOptions}
                onChange={setLocationSelected}
                value={locationSelected}
                isSearchable
                isClearable
                components={{
                  DropdownIndicator: CustomDropdownIndicator,
                  Placeholder: CustomPlaceholder,
                  Option: CustomOption,
                }}
                classNamePrefix="custom-select"
                noOptionsMessage={({ inputValue }) => 
                  inputValue.length < 3 
                    ? 'Digite pelo menos 3 caracteres' 
                    : 'Nenhuma opção disponível'
                }
                loadingMessage={() => 'Carregando...'}
                defaultOptions={false}
                cacheOptions
                debounceTimeout={300}
              />
            </SelectCustom>
          </div>

          <div className="field" style={{ minWidth: '200px' }}>
            <SelectCustom>
              <Select
                instanceId="department-select"
                id="seingle-select"
                className="custom-select"
                classNamePrefix="custom-select"
                placeholder="Departamento"
                options={optionsDepartments}
                onChange={e => setDepartmentSelected(e)}
                value={departmentSelected}
                isClearable
              />
            </SelectCustom>
          </div>
          <div className="field" style={{ minWidth: '140px' }}>
            <SelectCustom>
              <Select
                instanceId="regime-select"
                id="seingle-select"
                className="custom-select"
                classNamePrefix="custom-select"
                placeholder="Regime"
                isClearable
                options={optionsRegime}
                onChange={e => setRegimeSelected(e)}
                value={regimeSelected}
              />
            </SelectCustom>
          </div>
          <div className="field" style={{ minWidth: '140px' }}>
            <SelectCustom>
              <Select
                instanceId="model-select"
                id="seingle-select"
                className="custom-select"
                classNamePrefix="custom-select"
                placeholder="Modelo"
                isClearable
                options={optionsModel}
                onChange={e => setModelSelected(e)}
                value={modelSelected}
              />
            </SelectCustom>
          </div>
        </RowSearch>
        <Row className="row-exp">
          <h4>Buscas que podem ser realizadas: </h4>
          <p>excel</p>
          <p>php</p>
          <p>assistente</p>
          <p>desenvolvedor</p>
          <p>marketing</p>
        </Row>
      </Card>
    </Container>
  );
}

export default Search;
